
import { EnhancedButton } from "@/components/ui/enhanced-button";
import { ArrowRight, CheckCircle, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface BusinessAssessmentPromptProps {
  onAssessmentComplete: () => void;
}

export default function BusinessAssessmentPrompt({ onAssessmentComplete }: BusinessAssessmentPromptProps) {
  const navigate = useNavigate();

  const handleStartAssessment = () => {
    navigate("/assessment");
  };

  return (
    <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
      <div className="flex items-start space-x-4 flex-1">
        <div className="flex-shrink-0">
          <div className="relative">
            <CheckCircle className="h-8 w-8 text-cso-600" />
            <Clock className="h-4 w-4 text-orange-500 absolute -top-1 -right-1" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">
            Complete Your Business Assessment
          </h3>
          <p className="text-gray-600 text-sm sm:text-base mb-3">
            Unlock personalized strategic advice and pre-filled document templates. Takes just 5 minutes and dramatically improves your experience.
          </p>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-xs sm:text-sm text-gray-500">
            <span className="flex items-center gap-1">
              ✓ Personalized document templates
            </span>
            <span className="flex items-center gap-1">
              ✓ Smarter AI recommendations
            </span>
            <span className="flex items-center gap-1">
              ✓ Industry-specific insights
            </span>
          </div>
        </div>
      </div>
      <div className="w-full sm:w-auto">
        <EnhancedButton
          onClick={handleStartAssessment}
          className="w-full sm:w-auto bg-gradient-to-r from-cso-600 to-cso-700 hover:from-cso-700 hover:to-cso-800 text-white"
          size="xl"
          variant="default"
        >
          <span className="hidden sm:inline">Start Assessment</span>
          <span className="sm:hidden">Start Now</span>
          <ArrowRight className="h-5 w-5 ml-2" />
        </EnhancedButton>
      </div>
    </div>
  );
}
